export default {
    'reminder-type': 'نوع تذكير',
    'delete-message-reminder-type': 'هل أنت متأكد من أنك تريد حذف نوع التذكير هذا؟'
}